import SearchRequest from "@solundo/webshop/js/SearchRequest";
import Collapse from "@solundo/webshop/js/Collapse";
import EqualHeights from "@solundo/webshop/js/EqualHeights/EqualHeights";
import Materiallist from "@solundo/webshop/js/Materiallist/Materiallist";
import NumberInput from "@solundo/webshop/js/NumberInput/NumberInput";

class Configurator {
	withReload = false;

	constructor(config) {
		this.config = Object.assign({
			scope: '[data-configurator="scope"]',
			tabs: '[data-configurator="tabs"]',
			filters: '[data-configurator="filters"]',
			filter: '[data-configurator="filter"]',
			options: '[data-configurator="options"]',
			option: '[data-configurator="option"]',
			loader: '[data-configurator="loader"]',
			toolbar: '[data-configurator="toolbar"]',
			summary: '[data-configurator="summary"]',
			aiModal: '[data-configurator="ai-modal"]',
			package: '[data-configurator="package"]',
			label: '[data-configurator="label"]',
			extra: '[data-configurator="extra"]',
			saveConfiguration: '[data-configurator="save-configuration"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		let params = Object.fromEntries(new URLSearchParams(location.search));

		// Only scroll to position if user goes back in window history.
		// or "back to the future" :)
		if(performance.navigation.type == 2 || (params['scrollToPosition'] && params['scrollToPosition'] == 1)) {
	 		window.scrollTo(0, localStorage.getItem('scrollPos'));
		}

		$(window).on('popstate', function() {
			// Saves the current scroll position before reloading the page.
			localStorage.setItem('scrollPos', window.pageYOffset || document.documentElement.scrollTop);
			location.reload();
		});

		this.initRequest();
		this.addEventListeners();
		this._initPackages();
	}

	initRequest() {
		this.filterCollapse = new Collapse({
			group: '[data-collapse="group"][data-group="filters"]',
			namespace: 'filters-collapse'
		});

		this.optionCollapse = new Collapse({
			group: '[data-collapse="group"][data-group="options"]',
			namespace: 'options-collapse'
		});

		new Collapse({
			scope: '[data-bs-target="#extra-options"]',
			group: '[data-configurator="options"]',
			namespace: 'extra-options-collapse'
		});

		this.extraCollapse = new Collapse({
			scope: '.construction-group [data-toggle="custom-collapse"]',
			namespace: 'construction-group-collapse'
		});

		this.request = SearchRequest;
		this.request.pushHistory = true;
		this.request.handleResponse = this._handleResponse.bind(this);
		this.$scope.find(`${this.config.filter}:checked`).each((index, element) => this._toggleFilterByInput($(element)));
		this.$scope.find(`${this.config.option}:checked`).each((index, element) => this._toggleOptionByInput($(element)));
		this.$scope.find(`${this.config.extra}:checked`).each((index, element) => this._toggleExtraByInput($(element)));
	}

	addEventListeners() {
		this.$scope.on('change', this.config.filter, this.filterChanged.bind(this));
		this.$scope.on('change', this.config.option, this.optionChanged.bind(this));
		this.$scope.on('change', this.config.extra, this.extraChanged.bind(this));
		this.$scope.on('click', `${this.config.label}[data-type="filter"]`, this.filterLabelClicked.bind(this));
		this.$scope.on('click', `input:disabled + ${this.config.label}[data-type="filter"]`, this.resetFilter.bind(this));
		this.$scope.on('click', `input:checked + ${this.config.label}[data-type="option"]`, (event) => this.optionLabelClicked($(event.currentTarget)));
		this.$scope.on('click', `${this.config.label}[data-type="extra"]`, this.extraLabelClicked.bind(this));
		this.$scope.on('click', this.config.package, this.selectPackage.bind(this))
		this.$scope.on('click', this.config.saveConfiguration, this.saveConfiguration.bind(this));
		this.$scope.on('click', '[data-configurator="back"]', this.back.bind(this));
	}

	resetFilter(event) {
		localStorage.setItem('previous-configuration', window.location.href);

		try {
			let toast = bootstrap.Toast.getOrCreateInstance(document.querySelector('[data-configurator="danger"]'));
			toast.show();
		} catch (error) {
			console.log(error);
		}


		let $label = $(event.currentTarget);
		let $input = $label.parent().find(this.config.filter)
		delete this.request.request.filter;
		// delete this.request.request.option;
		delete this.request.request.amounts;
		this._toggleFilterByInput($input);
		this.request.setByKeyValue('type', 'filter')
		this._doRequest();
	}

	filterLabelClicked(event) {
		let $label = $(event.currentTarget);
		let $input = $(`#${$label.attr('for')}`);
		if($input.is(':disabled')) {
			return;
		}
		let currentIndex = $label.closest('.custom-collapse').find('[data-toggle="custom-collapse"]').data('index');
		this.filterCollapse._openByIndex(currentIndex + 1, true);
	}

	filterChanged(event) {
		let $input = $(event.currentTarget);
		this.request.setByKeyValue('type', 'filter')
		this._toggleFilterByInput($input);

		if ($input.data('tree-id') == '262') {
			this.withReload = true;
			this._doRequest(true);
		} else {
			this.withReload = false;
			this._doRequest();
		}
	}

	optionLabelClicked($label) {
		let $input = $(`#${$label.attr('for')}`);
		if($input.is(':disabled')) {
			return;
		}
		let currentIndex = $label.closest('.custom-collapse').find('[data-toggle="custom-collapse"]').data('index');
		this.optionCollapse._openByIndex(currentIndex + 1, true);
	}

	async optionChanged(event) {
		let $input = $(event.currentTarget);
		this.request.setByKeyValue('type', 'option')
		this._toggleOptionByInput($input);
		this._doRequest().then(() => this.optionLabelClicked($input.parent().find('label')));
	}

	extraLabelClicked(event) {
		let $label = $(event.currentTarget);
		let $input = $(`#${$label.attr('for')}`);
		if($input.is(':disabled')) {
			return;
		}
		let $button = $input.closest('.custom-collapse').find('[data-toggle="custom-collapse"]');
		this.extraCollapse._close($button);
		this.filterCollapse._openByIndex(0);
	}

	extraChanged(event) {
		let $input = $(event.currentTarget);
		let newLabel = $input.parent().find('[data-extra-value-label]').html();
		let $collapse = $input.closest('.custom-collapse');
		let $value = $collapse.find('[data-collapse-value]')
		$value.html(newLabel);

		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			let $input = $(event.currentTarget);
			this._toggleExtraByInput($input)
			this._doRequest();
		}, 50);
	}

	_toggleExtraByInput($input) {
		this.request.setByKeyValue('type', null)
		this.request.setByKeyValue($input.attr('name'), $input.val());
	}

	selectPackage(event) {
		event.preventDefault();
		let $target = $(event.currentTarget);
		let message = $target.closest('[data-package-message]').data('package-message');

		if(!confirm(message)) {
			return;
		}

		showLoader();
		this.$scope.find(this.config.loader).addClass('loading');
		$.ajax({
			method: 'POST',
			data: {
				action: 'selectPackage',
				package: $target.data('package-id')
			},
			success: () => {
				location.replace(location.pathname + '#opties')
				location.reload();
			}
		});
	}

	saveConfiguration(event) {
		event.preventDefault();
		$.ajax({
			url: window.location.pathname,
			method: 'post',
			data: {
				action: 'saveConfiguration'
			},
			success: (response) => {
				let message = `
					De code voor deze configuratie is: ${response.code}\r\n\r\nSla deze code op in het CMS onder \r\n"gekoppelde module > Code vooringevulde configuratie"\r\n\r\nof gebruik het in een url \r\n${response.url}?code=${response.code}
				`.trim();

				alert(message);
			}
		});
	}

	_toggleFilterByInput($input) {
		let treeId = $input.data('tree-id');
		if(this.request.hasFilterGroup(treeId)) {
			this.request.clearFilterByTreeId(treeId);
		}
		this.request.addFilter(treeId, $input.data('id'), $input.data('title'));
	}

	_toggleOptionByInput($input) {
		let groupId = $input.data('group-id');

		if($input.data('parent-id')) {
			groupId = `${$input.data('parent-id')}||${groupId}`;
		}
		if(this.request.hasOptionGroup(groupId)) {
			this.request.clearOptionByGroupId(groupId);
		}

		if(this.request.hasSubproductGroup(groupId)) {
			this.request.clearSubproductsByGroupId(groupId);
		}

		if($input.data('id')) {
			this.request.addOption(groupId, $input.data('id'), $input.data('amount'));
			this.request.addSubproduct(groupId, $input.data('product-id'), $input.data('subproduct-id'));
		}
	}

	_doRequest(withReload = false) {
		showLoader();
		this.$scope.find(this.config.loader).addClass('loading');
		return this.request.doRequest(withReload);
	}

	_handleResponse(response) {
		this.$scope.find(this.config.filters).html(response.filters);
		this.$scope.find(this.config.options).html(response.options);
		this.$scope.find(this.config.tabs).html(response.tabs);
		this.$scope.find(this.config.toolbar).html(response.toolbar);
		this.$scope.find(this.config.summary).html(response.summary);
		// niet elke configurator (bv. schuifwanden) levert een ai-modal mee
		if(response.aiModal !== undefined) {
			this.$scope.find(this.config.aiModal).html(response.aiModal).trigger('image-ai:init');
		}
		if(!this.withReload) {
			this.$scope.find(this.config.loader).removeClass('loading');
		}
		this._initPackages();

		if(!this.withReload) {
			hideLoader();
		}
	}

	_initPackages() {
		new Materiallist();
		new NumberInput({
			scope: `${this.config.scope} [data-number="scope"]`
		});
		new EqualHeights({
			scope: '[data-configurator-equal-heights="scope"]',
			item: '[data-configurator-equal-heights="item"]'
		});
	}

	back(event) {
		event.preventDefault();

		let prev = localStorage.getItem('previous-configuration');

		let matches = Array.from(prev.matchAll(/(.*?)\/(\?.*)./g));

		let queryString = null;
		let url = null;
		if(matches[0] && matches[0][2]) {
			url = matches[0][1]
			queryString = matches[0][2]
		}

		let params = {};
		if(queryString) {
			params = Object.fromEntries(new URLSearchParams(queryString));
		}

		params['scrollToPosition'] = 1;
		localStorage.setItem('scrollPos', window.pageYOffset || document.documentElement.scrollTop)

		let newQueryString = (new URLSearchParams(params)).toString();

		location.href = `${url}?${newQueryString}`;
	}
}

export default new Configurator;